export function ReadableDate(date) {
    return date
        ? new Date(date).toLocaleDateString("nl-nl", {
            year: "numeric",
            month: "long",
            day: "numeric",
        })
        : "-";
}
export function ReadableDateTime(date) {
    return date
        ? ReadableDate(date) +
            " " +
            new Date(date).toLocaleTimeString("nl-nl", {
                hour: "numeric",
                minute: "numeric",
            })
        : "-";
}
